export default "__VITE_ASSET__BcK1GMgv__"